/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

const actions = {


  updateI18nLocale({ commit }, locale) {
    commit("updateI18nLocale", locale);
  },

  updateUserInfor({ commit }, userInfor) {
    commit("updateUserInfo", userInfor);
  },
  // set giá trị cho vị trí công viẹc
  setDataJobPosition({ commit }, dataJobPosition) {
    commit("setDataJobPosition", dataJobPosition);
  },
  // set giá trị cho cơ cấu tổ chức
  setDataOrganization({ commit }, dataOrganization) {
    commit("setDataOrganization", dataOrganization);
  },
  // set giá trị cho cơ cấu tổ chức
  setDataOrganizationCommon({ commit }, dataOrganizationCommon) {
    commit("setDataOrganizationCommon", dataOrganizationCommon);
  },
  //set giá trị cho cơ cấu tổ chức chứa đơn vị ngưng hoạt động
  setDataOrganizationCommonInactive(
    { commit },
    dataOrganizationCommonInactive
  ) {
    commit("setDataOrganizationCommonInactive", dataOrganizationCommonInactive);
  },
  setSelectedCount({ commit }, selectedCount) {
    commit("setSelectedCount", selectedCount);
  },
  setEditingMode({ commit }, isEditingMode) {
    commit("setEditingMode", isEditingMode);
  },
  // Lưu danh sách quyền người dùng
  setListRole({ commit }, listRole) {
    commit("setListRole", listRole);
  },
  // Lấy ra danh sách trạng thái mở cây của tree list
  setExpandedTreeList({ commit }, expandedTreeList) {
    commit("setExpandedTreeList", expandedTreeList);
  },
  // Lưu danh sách cột các màn hình grid
  setGridConfig({ commit }, gridConfig) {
    commit("setGridConfig", gridConfig);
  },
  setUserOptions({ commit }, userOptions) {
    commit("setUserOptions", userOptions);
  },
  setLstReportMaster({ commit }, lstReportMaster) {
    commit("setLstReportMaster", lstReportMaster);
  },
  setStateLoadListProcess({ commit }, stateLoadListProcess) {
    commit("setStateLoadListProcess", stateLoadListProcess);
  },
  setExecutorFirstStep({ commit }, executorFirstStep) {
    commit("setExecutorFirstStep", executorFirstStep);
  },
  setAmountNeesToDo({ commit }, amount) {
    commit("setAmountNeesToDo", amount);
  },
  setActiveMenu({ commit }, activeMenu) {
    commit("setActiveMenu", activeMenu);
  },
  // Cập nhật giá trị 
  updateCompanyConflicts({ commit }, conflicts) {
    commit('setCompanyConflicts', conflicts);
  },
  updateCompanyList({ commit }, list) {
    commit('setCompanyList', list);
  },
  updateCompanyInfos({ commit }, list) {
    commit('setCompanyInfos', list);
  },
};

export default actions;
